// import React from 'react'
// import { Doughnut } from 'react-chartjs-2'
// import { withTranslation } from 'react-i18next'



// const options = {
//   scales: {
//     // y: {
//     //   beginAtZero: true
//     // }
//   },
//   maintainAspectRatio: false
// }

// export default withTranslation()(function Chart({data}) {

//   return (
//     <Doughnut
//       data={data}
//       options={options}
//       height={200}
//     />
//   )
// })

import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { withTranslation } from 'react-i18next'

export default withTranslation()(function Chart({ data, colors }) {
  const dataValue = data
  const COLORS = colors
  return (
    <ResponsiveContainer width="100%" height="80%" >
      <PieChart width={400} height={400}>
        <Tooltip />
        {/* <Pie data={data01} dataKey="value" cx="50%" cy="50%" outerRadius={60} fill="#8884d8" /> */}
        <Pie data={dataValue} dataKey="value" cx="50%" cy="50%" innerRadius={80} outerRadius={200} fill="#1976D2" >
          {
            dataValue.map((entry, index) => <Cell key={index} fill={COLORS[index % COLORS.length]} />)
          }
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  )
})
